// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1th2y","content":"styles_content__3_yvd"};